import { Link } from "react-router-dom";

import { useScans } from "../api/queries";
import "./pages.css";
import { Empty } from "../components/Empty";
import { ErrorBand } from "../components/ErrorBand";
import { Panel } from "../components/Panel";
import { Skeleton } from "../components/Skeleton";
import { TitleBand } from "../components/TitleBand";
import { duration, when } from "../format";
import { MODE_PAGES, modeHref, scanWalked } from "./scanRoute";

export function Scans() {
  const scans = useScans();

  if (scans.isLoading) {
    return (
      <>
        <TitleBand title="Scans" />
        <Skeleton rows={6} />
      </>
    );
  }

  if (scans.isError) {
    return (
      <>
        <TitleBand title="Scans" />
        <ErrorBand
          message="Could not load the scans."
          hint="The server may be restarting. Reload in a moment."
        />
      </>
    );
  }

  const rows = scans.data ?? [];

  return (
    <>
      <TitleBand title="Scans" note={`${rows.length} most recent`} />
      <Panel primary>
        {rows.length === 0 ? (
          <Empty>
            No scans yet. Run <code>python -m market_analyzer scan</code> on the
            scanning machine, then <code>sync</code>.
          </Empty>
        ) : (
          <div className="scroll">
            <table>
              <thead>
                <tr>
                  <th>When</th>
                  <th>City</th>
                  <th>Source</th>
                  <th>Modes</th>
                  <th className="num">Offers</th>
                  <th className="num">Traders</th>
                  <th className="num">Took</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((scan) => (
                  <tr key={scan.scan_uid}>
                    <td>
                      <Link to={`/scans/${scan.scan_uid}`}>{when(scan.started_at)}</Link>
                    </td>
                    <td>{scan.city || <span className="dim">—</span>}</td>
                    <td className="dim">{scan.source}</td>
                    <td className="scan-modes">
                      {MODE_PAGES.map((mode) =>
                        scanWalked(scan, mode) ? (
                          <Link key={mode} to={modeHref(scan.scan_uid, mode)}>{mode}</Link>
                        ) : (
                          // Not a link: a page that can only say "this scan didn't walk craft" is
                          // not worth a click to find out.
                          <span key={mode} className="dim">{mode}</span>
                        ),
                      )}
                    </td>
                    <td className="num">{scan.offers_count}</td>
                    <td className="num">{scan.traders_count}</td>
                    <td className="num dim">
                      {scan.presumed_stopped ? (
                        <span title="Started long ago and never closed — the machine probably lost power.">
                          stopped
                        </span>
                      ) : (
                        duration(scan.started_at, scan.ended_at)
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </>
  );
}
